module.exports = __webpack_public_path__ + "static/vascepaPill-35dc838258237cbc3399e97c6d2c6756.png";